<template>
  <div :class="['container',  _isMobile()?'mobile':'']">
    <a-divider />
    <a-card class="search-card" :bordered="false">
      <j-dict-select-tag
        :defaultShowAll="true"
        type="radioButton"
        @change="handleChangeType"
        v-model="paperType"
        :trigger-change="true"
        dictCode="paper_type"
      />
    </a-card>
    <a-divider />
    <a-card :bordered="false">
      <a-list :dataSource="paperDataSource" :pagination="pagination">
          <a-list-item slot="renderItem" slot-scope="item">
              <h3><a-tag>{{ item.paperType_dictText }}</a-tag>{{ item.paperName }}</h3>
              <div slot="actions">
                <a-tag v-if="!_isMobile()">考试时间 {{ item.timeLimit }} 分钟</a-tag>
                <a-tag v-if="!_isMobile()">总分 {{ item.totalScore }} 分</a-tag>
                <a-tag v-if="!_isMobile()">限次：{{ item.mySubmitTimes?item.mySubmitTimes+"/":"" }}{{item.submitTimesLimit==-1?"不限":item.submitTimesLimit}}</a-tag>
                <a-button class="to-exam-btn" v-if="item.userPaperStatus>0 && (item.submitTimesLimit==-1 || (item.submitTimesLimit>item.mySubmitTimes))" 
                  size="small" @click="toPaper(item, true)">再次考试</a-button>
                <a-divider type="vertical"/>
                <a-button class="to-exam-btn" size="small" @click="toPaper(item, false)">
                  {{item.userPaperStatus==0?'继续考试':(item.userPaperStatus==1||item.userPaperStatus>1?'查看答卷':'去考试')}}
                <a-icon type="right"/></a-button>
                <!-- <a-button v-if="item.userPaperStatus==null||item.userPaperStatus==0" class="to-exam-btn" size="small" @click="toDetail(item.id || item.paperId)">参加考试<a-icon type="right"/></a-button>
                <a-button v-if="item.userPaperStatus>0" class="to-exam-btn" size="small">已交卷<a-icon type="right"/></a-button> -->
              </div>
          </a-list-item>
        </a-list>
    </a-card>
  </div>
</template>

<script>

import Vue from "vue";
import { TENANT_CONFIG,ACCESS_TOKEN } from "@/store/mutation-types";
import config from '../theme.config'
import {getAction} from "@/api/manage"
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import {mixinDevice} from '@/utils/mixin.js'

export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
  },
  data() {
    return {
      paperDataSource: [
      ],
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: this._isMobile()?12:15,
      },
      loading: true,
      paperType: "",
      token: '',
      tenantConfig:{}
    };
  },
  created() {
    if (Vue.ls.get(ACCESS_TOKEN)){
      this.token = Vue.ls.get(ACCESS_TOKEN)
    }
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    this.getPaperList()
  },
  mounted(){
    window.document.title = this.tenantConfig.brandName + " " + "考试题库"
  },
  methods: {
    handleChangeType(v) {
      this.paperType = v.target.value
      this.getPaperList()
    },
    getPaperList(){
      this.loading = true
      this.paperDataSource = []
      if(this.token){
        getAction('/teaching/teachingPaper/minePaperList', {
          paperType: this.paperType,
          pageSize: 999,
        }).then((res) => {
          if (res.success) {
            this.paperDataSource = this.paperDataSource.concat(res.result)
            this.duplicateRemove()
          }
          this.loading = false
        })
      }
      getAction("/teaching/teachingPaper/list", {
        paperType: this.paperType, 
        userPaperStatus:0,
        pageSize:999, 
        paperStatus:2
        }).then(res=>{
        if(res.success){
          this.paperDataSource = this.paperDataSource.concat(res.result.records)
          this.duplicateRemove()
        }
        this.loading = false
      })
    },
    duplicateRemove(){
      let ids = []
      for(let i in this.paperDataSource){
        let paperId
        if("paperId" in this.paperDataSource[i]){
          paperId = this.paperDataSource[i].paperId
        }else{
          paperId = this.paperDataSource[i].id
        }
        if(ids.includes(paperId)){
          //删除重复
          this.paperDataSource.splice(i,i)
        }else{
          ids.push(paperId)
        }
      }
      console.log(ids);
    },
    toDetail(id){
      // window.location.href = config.adminUrl + `/teaching/minePaper/list?token=${this.token}`
      //window.location.href = config.adminUrl + `examine?id=${id}&token=${this.token}`
      this.$router.push({
        path: '/examine',
        query: {
          id: id,
        },
      })
    },
    toPaper(info, redo) {
      let that = this
      if(info.userPaperStatus == null){
        this.$confirm({
          title: '提示',
          content: '确定参加考试吗? 开始后不可暂停考试',
          onOk() {
            if(redo){
              that.redoExam(info)
            }else{
              that.toExam(info)
            }
          },
          onCancel() {
          },
        });
        
      }else{
        if(redo){
          that.redoExam(info)
        }else{
          that.toExam(info)
        }
      }
    },
    redoExam(info){
      let paperId
      if("paperId" in info){
        paperId = info.paperId
      }else{
        paperId = info.id
      }
      this.$router.push({
       path: '/examine',
        query: {
          id: paperId,
          departId: info.departId,
        },
      })
    },
    toExam(info){
      let paperId
      if("paperId" in info){
        paperId = info.paperId
      }else{
        paperId = info.id
      }
      this.$router.push({
        path: '/examine',
        query: {
          id: paperId,
          departId: info.departId,
          userPaperId: info.userPaperId
        },
      })
    }
  },
};
</script>

<style lang="less" scoped>
.to-exam-btn{
  background:rgb(159,159,159);
  color: white;
}
.search-card{
  /deep/.ant-card-body{
    padding: 20px;
  }
}
</style>